if(document.querySelector('body').classList.contains('template-suffix-subscription')){

}else{
  if(Object.keys(apConfig).length > 0 && document.querySelector('.cart-subtotal') != null){
    const cartTotal = document.querySelector('.cart-subtotal').dataset.amount;
    const apConfig = {
      priceSelector: '.cart-footer__total-price',
      locale: 'en_US',
      currency: 'USD',
      afterpayLogoColor: 'white',
      showUpperLimit: false,
      amount: cartTotal,
      minMaxThreshold: {
        min: 100,
        max: 100000,
      },
    };
    new presentAfterpay(apConfig).init();
  }
  if(apConfig != undefined){
    if(Object.keys(apConfig).length > 0 && document.querySelector('body').classList.contains('template-cart') && document.querySelector('.cart-subtotal') != null){
      const cartTotal = document.querySelector('.cart-subtotal').dataset.amount;
      const apConfig = {
        priceSelector: '.cart-policies',
        locale: 'en_US',
        currency: 'USD',
        afterpayLogoColor: 'white',
        showUpperLimit: false,
        amount: cartTotal,
        minMaxThreshold: {
          min: 100,
          max: 100000,
        },
      };
      new presentAfterpay(apConfig).init();
    }
    window.onload = function() {
      if(Object.keys(apConfig).length > 0 && document.querySelector('body').classList.contains('template-product')){
        const ap = new presentAfterpay(apConfig).init();
        // apConfig.priceSelector = '.main-mobile-price-selector';
        // new presentAfterpay(apConfig).init();
        // var price = document.querySelector('product-form.sticky-content-container .price');
        // var config = {childList: true, subtree: true };
      }  
    }
  }
}

async function ensureSingleMembership() {
  try {
    // Fetch current cart
    const cart = await fetch('/cart.js').then(res => res.json());

    // Find all line items with handle 'membership'
    const membershipItems = cart.items.filter(item => item.handle === 'inveterate-subscription-b387add1');
    if (membershipItems.length > 0) {
      document.querySelectorAll('.product-membership-widget').forEach(w => w.classList.add('added'));
      // Keep only the first item, and make sure its quantity = 1
      const [keepItem, ...duplicates] = membershipItems;

      // Prepare all updates
      const updates = {};

      if(membershipItems.length == 1 && membershipItems[0].quantity == 1){
        return;
      }

      // Set the first membership item to quantity 1
      updates[keepItem.key] = 1;

      // Set all duplicates' quantities to 0 (remove them)
      duplicates.forEach(item => {
        updates[item.key] = 0;
      });

      // Also check if total membership quantity > 1 in the same line (edge case)
      if (keepItem.quantity > 1) {
        updates[keepItem.key] = 1;
      }
    
      // If any changes are needed, apply them
      if (Object.keys(updates).length > 0) {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        }).then(res => res.json()).then(res => {
          document.querySelector('cart-drawer').cartRefreshHandler();
        });
      }
    }else{
      document.querySelectorAll('.product-membership-widget').forEach(w => w.classList.remove('added'));
    }
  } catch (error) {
    console.error('Error ensuring single membership:', error);
  }
}

document.addEventListener('on:cart:add', (event) => {
  setTimeout(function(){
    ensureSingleMembership();
  }, 300)
});
document.addEventListener('on:cart-drawer:before-open', (event) => {
  document.querySelectorAll('.zero-price').forEach(el => {
    el.innerHTML = Shopify.formatMoney(0, window.theme.settings.moneyWithoutCurrencyFormat);
  });
  if(location.pathname == '/community/membership'){
    
  }else{
    ensureSingleMembership();
  }
  
});